module.exports = __webpack_public_path__ + "img/draw-cuts-icon.aa3fd2ac.svg";